module.exports = __webpack_public_path__ + "static/media/ada-inherit.883c6372.png";